import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { canonicalApi, type ArchitectureRegistry, type RemediationStatus } from '../../api/canonical';

export function CanonicalDomainRegistryPage() {
  const [registry, setRegistry] = useState<ArchitectureRegistry | null>(null);
  const [remediation, setRemediation] = useState<RemediationStatus | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void canonicalApi.registry().then(setRegistry).catch((e) => setError(String(e)));
    void canonicalApi.remediation().then(setRemediation).catch(() => undefined);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex flex-wrap gap-4">
        <Link to="/architecture/consolidation" className="text-sm text-blue-600 hover:underline dark:text-blue-400">← Architecture Consolidation</Link>
        <Link to="/architecture/compliance" className="text-sm text-blue-600 hover:underline dark:text-blue-400">Enterprise Compliance →</Link>
      </div>
      <h1 className="mt-2 text-2xl font-semibold">Canonical Domain Registry</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">DEV-000058 — single owner enforcement, Amazon adapter consolidation, BLK-001 remediation.</p>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}

      <div className="mt-6 grid gap-4 sm:grid-cols-4">
        <div className="rounded-xl border p-4 dark:border-slate-700">
          <p className="text-sm text-slate-500">BLK-001 resolved</p>
          <p className="text-2xl font-semibold">{remediation?.blk001_resolved ? 'Yes' : 'No'}</p>
        </div>
        <div className="rounded-xl border p-4 dark:border-slate-700">
          <p className="text-sm text-slate-500">Amazon adapters</p>
          <p className="text-2xl font-semibold">{remediation?.adapters_registered ?? 0}</p>
        </div>
        <div className="rounded-xl border p-4 dark:border-slate-700">
          <p className="text-sm text-slate-500">Ops orchestration</p>
          <p className="text-2xl font-semibold">{remediation?.ops_orchestration ?? 0}</p>
        </div>
        <div className="rounded-xl border p-4 dark:border-slate-700">
          <p className="text-sm text-slate-500">Canonical modules</p>
          <p className="text-2xl font-semibold">{remediation?.canonical_modules ?? 16}</p>
        </div>
      </div>

      <section className="mt-8">
        <h2 className="text-lg font-medium">Aggregate ownership</h2>
        <div className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
          {(registry?.ownership ?? []).map((o) => (
            <div key={o.aggregate} className="rounded-lg border p-3 text-sm dark:border-slate-700">
              <p className="font-medium">{o.aggregate}</p>
              <p className="text-slate-500">Owner: {o.owner}</p>
              <p className="text-xs text-slate-400">{o.api_prefix}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-medium">Amazon adapters → canonical</h2>
        <div className="mt-3 space-y-2">
          {(registry?.amazon_adapters ?? []).map((a) => (
            <div key={a.service_id} className="rounded-lg border p-3 text-sm dark:border-slate-700">
              <p className="font-medium">{a.service_id} → {a.canonical_id}</p>
              <p className="text-slate-500">{a.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
